import { styled } from '$utils/theme'
import { Text } from '$views/components/Text'
import { rem } from 'polished'

interface Props {
  columnPosition?: string
}

export const StyledRow = styled.tr`
  border: 1px solid ${p => p.theme.colors.menu};
`

export const StyledCell = styled.td`
  border: 1px solid ${p => p.theme.colors.menu};
`

export const StyledText = styled(Text)`
  margin: ${p => rem(p.theme.sizes.mini)};
  ${p => p.theme.media.onlyMobile`
      margin: ${rem(p.theme.sizes.mini)} ${rem(p.theme.sizes.tiny)};
  `};
`

export const StyledCellTitle = styled.th.attrs({})<Props>`
  border: 1px solid ${p => p.theme.colors.menu};
  background-color: ${p => p.theme.colors.blue};
  ${p =>
    p.columnPosition === 'left' &&
    `
    border-right: 1px solid ${p.theme.colors.white};
  `}
    ${p =>
      p.columnPosition === 'center' &&
      `
    border-right: 1px solid ${p.theme.colors.white};
    border-left: 1px solid ${p.theme.colors.white};
  `}
    ${p =>
      p.columnPosition === 'right' &&
      `
    border-left: 1px solid ${p.theme.colors.white};
  `}
`



// WEBPACK FOOTER //
// ./src/views/Cookies/Cookies.style.ts